// extracted by mini-css-extract-plugin
module.exports = {"accordionComponentWrapper":"j9","header":"j-","accordionWrapper":"j_","accordionHeader":"ka","accordionIcon":"kb","accordionContent":"kc"};